import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      newsletter_subscribers: {
        Row: {
          id: string;
          email: string;
          name: string | null;
          subscribed_at: string;
          is_active: boolean;
        };
        Insert: {
          email: string;
          name?: string | null;
        };
      };
      orders: {
        Row: {
          id: string;
          user_id: string | null;
          order_number: string;
          status: string;
          subtotal: number;
          delivery_fee: number;
          vat: number;
          total: number;
          promo_code: string | null;
          discount: number;
          delivery_type: string;
          payment_method: string;
          full_name: string;
          email: string;
          phone: string;
          emirate: string;
          area: string;
          building: string | null;
          apartment: string | null;
          notes: string | null;
          estimated_delivery: string | null;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<Database['public']['Tables']['orders']['Row'], 'id' | 'created_at' | 'updated_at'>;
      };
      order_items: {
        Row: {
          id: string;
          order_id: string;
          product_id: number;
          product_name: string;
          product_image: string | null;
          product_category: string | null;
          quantity: number;
          unit_price: number;
          total_price: number;
          created_at: string;
        };
        Insert: Omit<Database['public']['Tables']['order_items']['Row'], 'id' | 'created_at'>;
      };
      reviews: {
        Row: {
          id: string;
          product_id: number;
          user_id: string;
          user_name: string;
          user_email: string | null;
          rating: number;
          title: string | null;
          body: string;
          verified_purchase: boolean;
          helpful_count: number;
          created_at: string;
        };
        Insert: Omit<Database['public']['Tables']['reviews']['Row'], 'id' | 'created_at' | 'helpful_count' | 'verified_purchase'>;
      };
    };
  };
};
